import Vue from 'vue';
//时间戳转化为时间格式：(根据mask展示效果，如yyyy-MM-dd HH:mm:ss)
Vue.prototype.formatDate = function(time_, mask) {
    time_ = typeof time_ === "string" ? time_.replace(/-/g, "/") : time_;
    var time = new Date(time_);
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var date = time.getDate();
    var hours = time.getHours();
    var minutes = time.getMinutes();
    var seconds = time.getSeconds();

    return mask.replace('yyyy', year).replace('MM', add0(month)).replace('dd', add0(date)).replace('HH', add0(hours)).replace('mm', add0(minutes)).replace('ss', add0(seconds));
};

//时间戳转化为日期时间：(根据mask展示效果，如2019年01月09日（星期三）)
Vue.prototype.formatDate1 = function(time) {
    var time = new Date(time);
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var date = time.getDate();
    var week = time.getDay();
    switch (week) {
        case 0:
            week = "星期日";
            break;
        case 1:
            week = "星期一";
            break;
        case 2:
            week = "星期二";
            break;
        case 3:
            week = "星期三";
            break;
        case 4:
            week = "星期四";
            break;
        case 5:
            week = "星期五";
            break;
        case 6:
            week = "星期六";
            break;
        default:
            week = "星期六";
            break;
    }
    return year + '年' + add0(month) + '月' + add0(date) + '日' + " " + week;
};

// 获取当天日期加星期
//补0处理
function add0(m) {
    return m < 10 ? '0' + m : m;
}
/**
 * [formatToStringTime 时间戳转换成 YYYY-MM-dd HH:mm:ss]
 * @param  {[type]} timestamp [description]
 * @return {[type]}           [description]
 */
Vue.prototype.formatToStringTime = function(timestamp, symbol) {
    if (!symbol) symbol = '-';
    let year, month, days, hours, minutes, seconds, time, result;
    year = timestamp.getFullYear();
    month = (timestamp.getMonth() + 1) < 10 ? '0' + (timestamp.getMonth() + 1) : timestamp.getMonth() + 1;
    days = timestamp.getDate() < 10 ? '0' + timestamp.getDate() : timestamp.getDate();
    hours = timestamp.getHours() < 10 ? '0' + timestamp.getHours() : timestamp.getHours();
    minutes = timestamp.getMinutes() < 10 ? '0' + timestamp.getMinutes() : timestamp.getMinutes();
    seconds = timestamp.getSeconds() < 10 ? '0' + timestamp.getSeconds() : timestamp.getSeconds();
    result = year + symbol + month + symbol + days + ' ' + hours + ':' + minutes + ':' + seconds;
    return result;
};
//将YYYYMMDD或者YYYY-MM-DD HH:mm:ss字符串转化为时间实例
Vue.prototype.dateFormatTo_date = function(day) {
    day = day.replace(/-/g, "/");
    var date = new Date(day);
    return date;
};